"use strict";

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bn_js_1 = __importDefault(require("bn.js"));

var rxjs_1 = require("rxjs");

var UniqueSubject = /*#__PURE__*/function (_rxjs_1$BehaviorSubje) {
  _inherits(UniqueSubject, _rxjs_1$BehaviorSubje);

  var _super = _createSuper(UniqueSubject);

  function UniqueSubject() {
    var _this;

    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UniqueSubject);

    options = Object.assign({
      compare: UniqueSubject.compare,
      prepare: function prepare(previousValue, nextValue) {
        return nextValue;
      }
    }, options);
    _this = _super.call(this, options.prepare(null, value));
    _this.options = options;
    return _this;
  }

  _createClass(UniqueSubject, [{
    key: "next",
    value: function next(value) {
      var _this$options = this.options,
          compare = _this$options.compare,
          prepare = _this$options.prepare;
      value = prepare(this.value, value);

      if (!compare(this.value, value)) {
        _get(_getPrototypeOf(UniqueSubject.prototype), "next", this).call(this, value);
      }
    }
  }, {
    key: "update",
    value: function update(value) {
      this.next(Object.assign(Object.assign({}, this.getValue() || {}), value));
    }
  }]);

  return UniqueSubject;
}(rxjs_1.BehaviorSubject);

exports.UniqueSubject = UniqueSubject;

UniqueSubject.compare = function (valueA, valueB) {
  var result = valueA === valueB;

  if (!result && valueA && valueB && typeof valueA === 'object' && typeof valueB === 'object') {
    if (bn_js_1.default.isBN(valueA) && bn_js_1.default.isBN(valueB)) {
      result = valueA.eq(valueB);
    } else if (Array.isArray(valueA) && Array.isArray(valueB)) {
      if (valueA.length === valueB.length) {
        result = !valueA.find(function (value, index) {
          return UniqueSubject.compare(value, valueB[index]);
        });
      }
    } else {
      var keysA = Object.keys(valueA);
      var keysB = Object.keys(valueB);

      if (UniqueSubject.compare(keysA, keysB)) {
        result = !keysA.find(function (key) {
          return UniqueSubject.compare(valueA[key], valueB[key]);
        });
      }
    }
  }

  return result;
};